import { r as registerInstance, c as createEvent, h, H as Host } from './index-662ec80e.js';
import { c as currentLocale, i as dateFormatNumeric, t } from './i18n-939e2dee.js';
import { p as propCheck, r as runWatchers, h as hasPropError, d as displayPropError } from './propCheck-e7571e3e.js';
import { x as vDatetime, y as vDatetimeMin, z as vDatetimeMax, K as vMinNumber, M as vMaxNumber, e as vPattern, b as vMinLength, a as vString, a1 as vUndefOr, Q as vBoolean, $ as vNullOr, t as vDate } from './validation-02b8d01d.js';

const dsInputDatetimeCss = "ds-input-datetime:not([is-without-styling]){display:block;position:relative}ds-input-datetime:not([is-without-styling]) .datepicker-container{top:4.9rem;position:absolute;z-index:3;background-color:var(--grey-300);border-radius:0.25rem;visibility:hidden;opacity:0;padding:0.5rem !important;box-shadow:var(--shadow-2);width:20rem;transition:visibility 0s 0.25s, opacity 0.25s linear}ds-input-datetime:not([is-without-styling]) .datepicker-container ds-button{padding:0}ds-input-datetime:not([is-without-styling]) .datepicker-container .help-info,ds-input-datetime:not([is-without-styling]) .datepicker-container .help-error{display:none}ds-input-datetime:not([is-without-styling]) .datepicker-container table{margin-top:1rem !important;width:100%}ds-input-datetime:not([is-without-styling]) .datepicker-container table thead td{text-align:center}ds-input-datetime:not([is-without-styling]) .datepicker-container table td{font-size:0.79012346rem;line-height:1.3rem;border-top:0.25rem solid var(--grey-300);color:var(--grey-900)}ds-input-datetime:not([is-without-styling]) .datepicker-container table td a{margin:0 auto;text-decoration:none;display:block;text-align:center;width:1.8rem;height:1.8rem;line-height:1.8rem;color:var(--grey-600)}ds-input-datetime:not([is-without-styling]) .datepicker-container table td a[href]{color:var(--black)}ds-input-datetime:not([is-without-styling]) .datepicker-container table td.today a,ds-input-datetime:not([is-without-styling]) .datepicker-container table td a[href]:hover,ds-input-datetime:not([is-without-styling]) .datepicker-container table td.selected a{border-radius:100%}ds-input-datetime:not([is-without-styling]) .datepicker-container table td.today a{background:var(--grey-500)}ds-input-datetime:not([is-without-styling]) .datepicker-container table td a[href]:hover{background:var(--white)}ds-input-datetime:not([is-without-styling]) .datepicker-container table td.selected a,ds-input-datetime:not([is-without-styling]) .datepicker-container table td.selected a:hover{background:var(--primary);color:white}ds-input-datetime:not([is-without-styling])[is-open] .datepicker-container{visibility:visible;opacity:1;transition:visibility 0s, opacity 0s linear}ds-input-datetime:not([is-without-styling])[is-mini] .datepicker-container{top:3.5rem}ds-input-datetime:not([is-without-styling])[is-float-label] .datepicker-container{top:3.1rem}ds-input-datetime:not([is-without-styling])[is-float-label][is-mini] .datepicker-container{top:2.4rem}";

const DsInputDatetime = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.dsInput = createEvent(this, "dsInput", 7);
    this.daysOfWeek = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    this.months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'July', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    this.today = (new Date()).toJSON().split('T')[0];
    this.propError = {};
    this.datePartIndex = undefined;
    this.imaskPattern = '';
    this.placeholder = '';
    this.currentLocale = currentLocale();
    this.name = undefined;
    this.label = '';
    this.helperText = undefined;
    this.isFloatLabel = false;
    this.isMini = false;
    this.isDisabled = false;
    this.isReadonly = false;
    this.isWithoutStyling = false;
    this.isRequired = false;
    this.isClearable = false;
    this.dateValue = undefined;
    this.timeValue = undefined;
    this.dsInputValue = undefined;
    this.value = null;
    this.max = '2999-12-31T23:23:59';
    this.min = '1900-01-01T00:00:00';
    this.initialPosition = undefined;
    this.withSeconds = false;
    this.isOpen = false;
    this.currentMonth = parseInt(this.today.split('-')[1], 10);
    this.currentYear = parseInt(this.today.split('-')[0], 10);
    this.displayYear = this.currentYear;
  }
  updateLocale() {
    this.currentLocale = currentLocale();
    const exampleDate = dateFormatNumeric(new Date('1324-12-28T00:00:00.000Z'), true);
    const dateParts = exampleDate.replace(/\D+/g, ' ').split(' ');
    this.datePartIndex = {
      day: dateParts.findIndex((d) => d === '28'),
      month: dateParts.findIndex((m) => m === '12'),
      year: dateParts.findIndex((y) => y === '1324')
    };
    this.imaskPattern = exampleDate
      .replace(/(\D)/g, '{$1}') // quote anything not a number
      .replace(/[0-9]/g, '0') // numbers to masked numbers
      .replace(/\b00\b/g, '`0[0]') // 2 digit day/month, optional digit, prevent shiftback
      .replace(/\b0000\b/, '`0000') // 4 digit year, prevent shiftback
      + ' `00:`00'; // time, prevent shiftback
    this.placeholder = exampleDate
      .replace(/\b28\b/, 'dd')
      .replace(/\b12\b/, 'mm')
      .replace(/\b1324\b/, 'yyyy')
      + ' hh:mm';
    if (this.withSeconds) {
      this.imaskPattern += ':`00';
      this.placeholder += ':ss';
    }
  }
  watchName() {
    /* istanbul ignore if */
    if (!propCheck(this, 'name', 'string', vMinLength(1)))
      return;
  }
  watchLabel() {
    /* istanbul ignore if */
    if (!propCheck(this, 'label', 'string', vString))
      return;
  }
  watchHelperText() {
    /* istanbul ignore if */
    if (!propCheck(this, 'helperText', 'string', vUndefOr(vString)))
      return;
  }
  watchIsFloatLabel() {
    /* istanbul ignore if */
    if (!propCheck(this, 'isFloatLabel', 'boolean', vBoolean))
      return;
  }
  watchIsMini() {
    /* istanbul ignore if */
    if (!propCheck(this, 'isMini', 'boolean', vBoolean))
      return;
  }
  watchIsDisabled() {
    /* istanbul ignore if */
    if (!propCheck(this, 'isDisabled', 'boolean', vBoolean))
      return;
    if (this.isDisabled)
      this.dsInput.emit(null);
  }
  watchIsReadonly() {
    /* istanbul ignore if */
    if (!propCheck(this, 'isReadonly', 'boolean', vBoolean))
      return;
  }
  watchIsWithoutStyling() {
    /* istanbul ignore if */
    if (!propCheck(this, 'isWithoutStyling', 'boolean', vBoolean))
      return;
  }
  watchIsRequired() {
    /* istanbul ignore if */
    if (!propCheck(this, 'isRequired', 'boolean', vBoolean))
      return;
  }
  watchIsClearable() {
    /* istanbul ignore if */
    if (!propCheck(this, 'isClearable', 'boolean', vBoolean))
      return;
  }
  splitDate(date) {
    const [datePart, timePart] = date.split('T');
    const [y, m, d] = datePart.split('-').map(v => parseInt(v, 10));
    if (!timePart)
      return { y, m, d };
    const [h, i, s] = timePart.split(':').map(v => parseInt(v, 10));
    return { y, m, d, h, i, s };
  }
  watchValue() {
    /* istanbul ignore if */
    if (!propCheck(this, 'value', 'DatetimeString | null', vNullOr(vDatetime)))
      return;
    if (!this.value) {
      this.dateValue = null;
      this.timeValue = null;
      this.dsInputValue = null;
      return;
    }
    const localTime = this.UTCToLocal(this.value);
    const { y, m, d, h, i, s } = this.splitDate(localTime);
    this.dateValue = `${y}-${this.padZero(m)}-${this.padZero(d)}`;
    this.timeValue = `${this.padZero(h)}:${this.padZero(i)}${this.withSeconds ? ':' + this.padZero(s) : ''}`;
    this.dsInputValue = this.isoToDisplay(localTime);
  }
  watchMax() {
    /* istanbul ignore if */
    if (!propCheck(this, 'max', 'DatetimeString', vDatetime))
      return;
    const { y, m, d } = this.splitDate(this.UTCToLocal(this.max));
    this.maxYear = y;
    this.maxMonth = m;
    this.maxDay = d;
  }
  watchMin() {
    /* istanbul ignore if */
    if (!propCheck(this, 'min', 'DatetimeString', vDatetime))
      return;
    const { y, m, d } = this.splitDate(this.UTCToLocal(this.min));
    this.minYear = y;
    this.minMonth = m;
    this.minDay = d;
  }
  watchInitialPosition() {
    /* istanbul ignore if */
    if (!propCheck(this, 'initialPosition', 'DateString', vUndefOr(vDate)))
      return;
    if (!this.initialPosition)
      return;
    const [y, m] = this.initialPosition.split('-').map(v => parseInt(v, 10));
    this.currentMonth = m;
    this.displayYear = this.currentYear = y;
  }
  watchWithSeconds() {
    /* istanbul ignore if */
    if (!propCheck(this, 'withSeconds', 'boolean', vBoolean))
      return;
    this.updateLocale(); // update masks and placeholders
  }
  async injectError(error) {
    return this.dsInputElement.injectError(error);
  }
  async hideError() {
    return this.dsInputElement.hideError();
  }
  async open() {
    clearTimeout(this.closeTimeout);
    if (this.isDisabled || this.isReadonly)
      return;
    this.isOpen = true;
  }
  async close() {
    clearTimeout(this.closeTimeout);
    this.closeTimeout = setTimeout(() => {
      this.isOpen = false;
    }, 100);
  }
  displayToIso(display) {
    if (!display)
      return null;
    const [datePart, timePart] = display.split(' ');
    const parts = datePart.replace(/\D+/g, ' ').split(' ').map(s => parseInt(s, 10));
    const day = parts[this.datePartIndex.day];
    const month = parts[this.datePartIndex.month];
    const year = parts[this.datePartIndex.year];
    if (day === undefined || isNaN(day) ||
      month === undefined || isNaN(month) ||
      year === undefined || isNaN(year))
      return null;
    /* istanbul ignore if */
    if (year < 1000 || year >= 10000)
      return null;
    const value = `${year}-${this.padZero(month)}-${this.padZero(day)}T${timePart}${this.withSeconds ? '' : ':00'}`;
    const parsedDate = new Date(Date.parse(value + '.000Z'));
    if (isNaN(parsedDate.getTime()))
      return null;
    return value;
  }
  isoToDisplay(iso) {
    const datePart = dateFormatNumeric(new Date(iso.split('T')[0] + 'T00:00:00.000Z'), true);
    const { h, i, s } = this.splitDate(iso);
    if (h !== undefined && i !== undefined && !this.withSeconds)
      return `${datePart} ${this.padZero(h)}:${this.padZero(i)}`;
    if (h !== undefined && i !== undefined && s !== undefined && this.withSeconds)
      return `${datePart} ${this.padZero(h)}:${this.padZero(i)}:${this.padZero(s)}`;
    return datePart;
  }
  validate(display) {
    let error;
    const value = this.displayToIso(display);
    if (this.isRequired || display)
      error = vDatetime(value);
    if (error)
      return error;
    if (!this.isRequired && !value)
      return;
    /* istanbul ignore else */
    if (this.min)
      error = vDatetimeMin(this.UTCToLocal(this.min))(value);
    if (error)
      return error;
    /* istanbul ignore else */
    if (this.max)
      error = vDatetimeMax(this.UTCToLocal(this.max))(value);
    if (error)
      return error;
  }
  padZero(n) {
    const s = n.toString();
    if (s.length === 1)
      return '0' + s;
    return s;
  }
  UTCToLocal(dateString) {
    const date = new Date(dateString + '.000Z');
    return `${date.getFullYear()}-${this.padZero(date.getMonth() + 1)}-${this.padZero(date.getDate())}T${this.padZero(date.getHours())}:${this.padZero(date.getMinutes())}:${this.padZero(date.getSeconds())}`;
  }
  ;
  localToUTC(dateString) {
    const date = new Date(dateString + '.000');
    return `${date.getUTCFullYear()}-${this.padZero(date.getUTCMonth() + 1)}-${this.padZero(date.getUTCDate())}T${this.padZero(date.getUTCHours())}:${this.padZero(date.getUTCMinutes())}:${this.padZero(date.getUTCSeconds())}`;
  }
  ;
  connectedCallback() {
    runWatchers(this);
    this.updateLocale();
  }
  render() {
    if (hasPropError(this))
      return displayPropError(this);
    const setMinMaxMonthForYear = () => {
      if (this.currentYear === this.maxYear && this.currentMonth > this.maxMonth) {
        this.currentMonth = this.maxMonth;
      }
      else if (this.currentYear === this.minYear && this.currentMonth < this.minMonth) {
        this.currentMonth = this.minMonth;
      }
    };
    const button = (icon, isDisabled, onClick) => (h("ds-button", { icon: icon, iconSize: '1rem', iconColor: 'var(--grey-900)', mode: "text", version: "monochrome", onClick: onClick, isDisabled: isDisabled, isMini: true }));
    let timeRegex;
    if (this.withSeconds) {
      timeRegex = /^([01]\d|2[0-3]):[0-5]\d:[0-5]\d$/;
    }
    else {
      timeRegex = /^([01]\d|2[0-3]):[0-5]\d$/;
    }
    return (h(Host, { "is-open": this.isOpen, onFocusin: () => this.open(), onFocusout: () => this.close() }, h("div", { class: "datepicker-container", tabIndex: 0 }, h("div", { class: "_flex:justify(space-between) _flex:align(center) _m:top(2)" }, button('prev', this.currentYear === this.minYear, () => {
      this.displayYear = this.currentYear = this.currentYear - 1;
      setMinMaxMonthForYear();
    }), h("ds-input-number", { name: "year", isMini: true, value: this.displayYear, class: "_m:x(2)", onDsInput: e => {
        e.preventDefault();
        e.stopPropagation();
        this.displayYear = e.detail;
        if (this.displayYear >= this.minYear && this.displayYear <= this.maxYear) {
          this.currentYear = this.displayYear;
          setMinMaxMonthForYear();
        }
      }, validate: v => vMinNumber(this.minYear)(v) || vMaxNumber(this.maxYear)(v) ? ' ' : undefined, style: { width: '7rem' } }), button('next', this.currentYear === this.maxYear, () => {
      this.displayYear = this.currentYear = this.currentYear + 1;
      setMinMaxMonthForYear();
    })), h("div", { class: "_flex:justify(space-between) _flex:align(center) _m:top(2)" }, button('prev', this.currentYear === this.minYear && this.currentMonth === this.minMonth, () => {
      if (this.currentMonth === 1) {
        this.currentMonth = 12;
        this.displayYear = this.currentYear = this.currentYear - 1;
      }
      else {
        this.currentMonth = this.currentMonth - 1;
      }
    }), h("ds-select", { name: "month", isSearchable: false, isMini: true, value: this.currentMonth, class: "_m:x(2)", onDsInput: e => {
        e.preventDefault();
        e.stopPropagation();
        this.currentMonth = Number(e.detail);
      }, style: { width: '7rem' } }, h("div", { slot: "value" }, this.months[this.currentMonth - 1]), h("div", { slot: "options" }, this.months.map((month, index) => h("ds-select-option", { value: index + 1, isDisabled: (this.currentYear === this.maxYear && (index + 1) > this.maxMonth) ||
        (this.currentYear === this.minYear && (index + 1) < this.minMonth) }, month)))), button('next', this.currentYear === this.maxYear && this.currentMonth === this.maxMonth, () => {
      if (this.currentMonth === 12) {
        this.currentMonth = 1;
        this.displayYear = this.currentYear = this.currentYear + 1;
      }
      else {
        this.currentMonth = this.currentMonth + 1;
      }
    })), h("table", null, h("thead", null, h("tr", null, this.daysOfWeek.map(day => h("td", null, day)))), h("tbody", null, this.tbody())), h("div", { class: "_flex:justify(center) _flex:align(center) _mtop-2", style: { "border-top": "1px solid var(--grey-600)" } }, h("strong", { class: "_my-2 _text-xs" }, t('dateTime.time')), h("ds-input-string", { class: "_mleft-3 _my-2", name: "time", isMini: true, value: this.timeValue, onDsInput: e => {
        e.preventDefault();
        e.stopPropagation();
        this.timeValue = e.detail;
        if (this.dateValue && timeRegex.test(this.timeValue)) {
          this.dsInput.emit(this.localToUTC(`${this.dateValue}T${this.timeValue}${this.withSeconds ? '' : ':00'}`));
        }
      }, placeholder: "hh:mm" + (this.withSeconds ? ':ss' : ''), mask: "`00:`00" + (this.withSeconds ? ':`00' : ''), validate: vPattern(timeRegex) }))), h("ds-input-string", { ref: el => this.dsInputElement = el, name: this.name, label: this.label, placeholder: this.placeholder, type: "text", helperText: this.helperText, isFloatLabel: this.isFloatLabel, isMini: this.isMini, isDisabled: this.isDisabled, isReadonly: this.isReadonly, isWithoutStyling: this.isWithoutStyling, isClearable: this.isClearable, value: this.dsInputValue, validate: (value) => this.validate(value), onDsInput: e => {
        e.preventDefault();
        e.stopPropagation();
        this.dsInputValue = e.detail || '';
        if (!e.detail) {
          this.dateValue = null;
          this.timeValue = null;
          this.dsInput.emit(null);
          return;
        }
        const iso = this.displayToIso(e.detail);
        if (!iso || iso.indexOf('T') === -1)
          return;
        this.dsInput.emit(this.localToUTC(iso));
      }, mask: this.imaskPattern }, h("div", { slot: "helperText" }, h("slot", { name: "helperText" })))));
  }
  tbody() {
    const startDate = new Date(`${this.currentYear}-${this.padZero(this.currentMonth)}-01T00:00:00.000Z`);
    const dayOffset = startDate.getDay();
    const endDate = new Date(startDate);
    endDate.setFullYear(this.currentYear, this.currentMonth, 0);
    const endDay = endDate.getDate();
    let day = 1;
    const tr = (week) => {
      const row = [];
      for (let dayOfWeek = 0; dayOfWeek < 7; dayOfWeek++) {
        if ((week == 0 && dayOfWeek < dayOffset) || day > endDay) {
          // previous or next month
          row.push(h("td", null));
        }
        else {
          // this month
          const isoDate = `${this.currentYear}-${this.padZero(this.currentMonth)}-${this.padZero(day)}`;
          let classes = [];
          if (isoDate === this.dateValue)
            classes.push('selected');
          if (isoDate === this.today)
            classes.push('today');
          if ((this.currentYear === this.maxYear && this.currentMonth === this.maxMonth && day > this.maxDay) ||
            (this.currentYear === this.minYear && this.currentMonth === this.minMonth && day < this.minDay)) {
            // date outside of selectable range
            row.push(h("td", null, h("a", null, day)));
          }
          else {
            // date inside selectable range
            row.push(h("td", { class: classes.join(' ') }, h("a", { href: "javascript:void(0)", onMouseDown: () => {
                this.dateValue = isoDate;
                if (this.timeValue) {
                  this.dsInput.emit(this.localToUTC(`${this.dateValue}T${this.timeValue}${this.withSeconds ? '' : ':00'}`));
                }
                else {
                  this.dsInputValue = this.isoToDisplay(isoDate);
                }
              } }, day)));
          }
          ++day;
        }
      }
      return row;
    };
    const rows = [];
    for (let week = 0; week < 6; week++) {
      rows.push(h("tr", null, tr(week)));
      if (day > endDay)
        break;
    }
    return rows;
  }
  static get watchers() { return {
    "name": ["watchName"],
    "label": ["watchLabel"],
    "helperText": ["watchHelperText"],
    "isFloatLabel": ["watchIsFloatLabel"],
    "isMini": ["watchIsMini"],
    "isDisabled": ["watchIsDisabled"],
    "isReadonly": ["watchIsReadonly"],
    "isWithoutStyling": ["watchIsWithoutStyling"],
    "isRequired": ["watchIsRequired"],
    "isClearable": ["watchIsClearable"],
    "value": ["watchValue"],
    "max": ["watchMax"],
    "min": ["watchMin"],
    "initialPosition": ["watchInitialPosition"],
    "withSeconds": ["watchWithSeconds"]
  }; }
};
DsInputDatetime.style = dsInputDatetimeCss;

export { DsInputDatetime as ds_input_datetime };
